import { AxiosResponse } from 'axios';
import SecureClient from '../SecureClient';
import { TandemFieldConfiguration } from './DTOs';

export default class TandemFieldsClient extends SecureClient {
	public getFields = (): Promise<AxiosResponse<TandemFieldConfiguration[]>> => {
		return this._api.get<TandemFieldConfiguration[]>(`TandemFields`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public getField = (fieldName: string): Promise<AxiosResponse<TandemFieldConfiguration>> => {
		return this._api.get<TandemFieldConfiguration>(`TandemFields/${fieldName}`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}
}